/* Copyright (c) 2023 GRIP.S Medien GmbH & Co.KG */

import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles } from '@material-ui/core/styles';
import { useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppBar from './components/core/menu/appBar';
import Menu from './components/core/menu/menu';
import Switcher from './components/core/menu/switcher';
import PageLoader from './components/PageLoader';
import routes from './config/routes';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: '100vh',
    overflow: 'auto',
  },
}));

const App = ({ scopes, onLogin }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(true);
  const [isReady, setIsReady] = useState(true);
  let ref = useRef();

  const toggleLoading = () => setIsReady((isReady) => !isReady);
  const toggleDrawer = () => setIsOpen((isOpen) => !isOpen);

  return (
    <Router>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar toggleDrawer={toggleDrawer} isOpen={isOpen} onLogin={onLogin} />
        <Menu toggleDrawer={toggleDrawer} isOpen={isOpen} scopes={scopes} />
        <main
          id='app-content'
          className={classes.content}
          ref={(newRef) => {
            ref = newRef;
          }}
        >
          <div className={classes.appBarSpacer} />
          {isReady && (
            <Switcher
              routes={routes}
              viewProps={{
                toggleLoading,
                scrollParent: ref,
              }}
              scopes={scopes}
            />
          )}
          {!isReady && <PageLoader isLoading hasColor isFixed />}
        </main>
      </div>
    </Router>
  );
};

export default App;
